export default class alertasService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/prioridades',
			"id": '/api/prioridades/:id',
			"new": '/api/prioridades',
			'delete': '/api/prioridades/:id',
            'update': '/api/prioridades'
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }

    update(data){
        let url = this.baseUrl + this.routes.update;
        return this.http.put(url, data);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/prioridadesService.js